<script setup lang="ts">
import { RouterLink } from 'vue-router';

withDefaults(
  defineProps<{
    variant?: 'primary' | 'second';
    size?: 'lg' | 'md';
    type?: 'button' | 'submit';
    to?: string;
    fit?: boolean;
    loading?: boolean;
    disabled?: boolean;
  }>(),
  { variant: 'primary', size: 'lg', type: 'button' },
);
</script>

<template>
  <component
    :is="to ? RouterLink : 'button'"
    :to="to"
    :type="to ? undefined : type"
    :disabled="to ? undefined : disabled || loading"
    :aria-busy="loading"
    class="flex cursor-pointer items-center justify-center rounded-[12px] px-3 text-[14px] leading-[1.4] font-semibold whitespace-nowrap transition-[filter] active:brightness-95 disabled:cursor-progress disabled:opacity-70 xl:px-5"
    :class="[
      fit ? 'w-full sm:w-auto sm:shrink-0' : 'w-full',
      size === 'lg' ? 'h-[62px]' : 'h-12',
      variant === 'primary'
        ? 'bg-primaire text-primaire-encre'
        : 'bg-second text-second-encre',
    ]"
  >
    <span
      v-if="loading"
      class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-transparent border-t-current"
    ></span>
    <slot v-else />
  </component>
</template>
